<template>
  <div class="container-fluid">
    <div class="row justify-content-between">
      <div class="mb-4">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Church Activities Attendance Report
        </div>
        <div class="s-14 py-0 text-dak">
          {{ branchItem ? branchItem.parentNames : "" }}
        </div>
        <!-- <div @click="goBack">
          <span class="s-18 fw-400 cursor-pointer text-black">
            <img src="../../../assets/goback.png" alt="" /> Go back</span
          >
        </div> -->
      </div>
      <div class="c-pointer">
        <el-dropdown trigger="click" class="w-100">
          <div class="d-flex default-btn text-dak w-100" size="large">
            <span class="mt-1 s-14 text-head" style="color: #0040ff"
              >Export</span
            >
            <div class="mt-0 ml-1">
              <el-icon :size="10" class="el-icon--right primary--text"
                ><ArrowDownBold
              /></el-icon>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(bookType, index) in bookTypeList"
                :key="index"
              >
                <a
                  class="no-decoration text-dark"
                  @click="downloadFile(bookType)"
                >
                  {{ bookType.name }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="row bg-gray-300 justify-content-center py-4 border-radius-8">
      <div class="col-md-12">
        <div class="row align-items-center">
          <div class="col-md-9 col-12">
            <div class="row align-items-center">
              <div class="col-md-3 col-12 text-left text-md-center">
                <div class="mr-2 w-100 s-14 fw-400 text-dak">Date Range</div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-0">
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-0">
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 mt-2 mt-md-1 mb-3 mb-md-0">
                <div class="col-md-12 px-0">
                  <SelectAllDropdown
                    :items="allEvents"
                    @selected-item="setSelectedEvent"
                  />
                  <!-- <el-select-v2
                    v-model="selectedEventID"
                    class="w-100 font-weight-normal report-select"
                    :options="
                      allEvents.map((i) => ({
                        label: i.text,
                        value: i.id,
                      }))
                    "
                    placeholder="Select Account"
                    @change="setSelectedEvent"
                    size="medium"
                  /> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-12">
            <div class="col-md-12 d-flex justify-content-end px-0">
              <el-button
                class="c-pointer report-button w-100"
                :color="primarycolor"
                :loading="loading"
                round
                @click="getActivityReport"
              >
                Generate Report
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="element-to-print" class="">
    <div
      class="container-fluid d-flex justify-content-center my-2"
      v-if="displayTitle"
    >
      <div class="head-text">Church Activities Attendance Report</div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="w-100 mb-2">
          <h5 class="ml-3 mt-4"></h5>
          <div
            class="round-border"
            v-show="activityReport.length > 0"
            :class="{ 'show-report': showReport, 'hide-report': !showReport }"
          >
            <!-- <PerformanceColumn
              :data="analysisReport"
              title="Service Performance Charhht"
            /> -->
            <PerformanceColumnChart
              domId="chart"
              title="Attendance Analysis Chart"
              distance="5"
              :titleMargin="10"
              :data="attendanceChart.series"
              :series="attendanceChart.categories"
              :seriesText="`Attendance analysis`"
            />
          </div>
        </div>
        <div
          class="area-chart w-100 mt-5 lineGrap"
          v-show="activityReport.length > 0"
          :class="{ 'show-report': showReport, 'hide-report': !showReport }"
        >
          <!-- <ReportAreaChart
            elemId="chart"
            domId="areaChart1"
            title="Attendance Analysis Line Graph"
            subtitle=""
            lineColor="#50AB00"
            :xAxis="series"
            :series="attendanceData"
          /> -->
          <LineChart
            domId="new-attendance-chart"
            title="Attendance Analysis Line Graph"
            header="Attendance Analysis "
            :categories="attendanceChart.categories"
            :seriesData="attendanceChart.series"
          />
          <!-- <ReportAreaChart
            elemId="chart"
            domId="areaChart1"
            title="Attendance Analysis Line Graph"
            subtitle=""
            lineColor="#50AB00"
            :xAxis="attendanceChart.series"
            :series="attendanceChart.categories"
          /> -->
        </div>

        <div class="w-100 mt-5">
          <h5 class="ml-3 mt-4"></h5>
          <div
            class="round-border"
            v-show="activityReport.length > 0"
            :class="{ 'show-report': showReport, 'hide-report': !showReport }"
          >
            <PerformanceColumn
              domId="attendanceChart"
              title="Attendance by Event & Category"
              :categories="attendanceChartData.categories"
              :series="attendanceChartData.series"
            />
            <!-- <PerformanceColumn
              domId="chart"
              title="Service Performance Chart"
              :series="FTNCDataChart.series"
              :categories="FTNCDataChart.categories"
              yAxisText="First Timer and New Convert Analysis"
            /> -->
            <!-- <PerformanceColumnChart
              domId="chart1"
              title="Attendance Analysis Chart By Category"
              distance="5"
              :titleMargin="10"
              :data="summaryChart"
              :series="attendanceSeries"
              :seriesText="`Attendance analysis`"
            /> -->
          </div>
        </div>
        <section class="w-100" v-if="false">
          <!-- table header -->
          <div class="row">
            <div
              class="col-md-12 d-flex justify-content-end"
              v-if="filteredAccount.length > 0 || searchText !== ''"
            >
              <div class="col-md-4 col-12 px-0 mt-5" v-if="!displayTitle">
                <el-input
                  v-model="searchText"
                  size="small"
                  placeholder="Search..."
                  :suffix-icon="Search"
                />
              </div>
            </div>
          </div>
          <div
            class="container-fluid table-main px-0 remove-styles2 remove-border responsiveness mb-5 mt-2"
            id="table"
            v-show="filteredAccount.length > 0"
            :class="{ 'show-report': showReport, 'hide-report': !showReport }"
          >
            <table
              class="table remove-styles mt-0 table-hover table-header-area"
            >
              <thead class="table-header-area-main">
                <tr
                  class="text-capitalize text-nowrap font-weight-bolder"
                  style="border-bottom: 0"
                >
                  <th scope="col">Event Name & Date</th>
                  <th scope="col">Category</th>
                  <th scope="col">Category Attendance</th>
                </tr>
              </thead>
              <tbody class="font-weight-bolder text-nowrap">
                <tr v-for="(item, index) in filteredAccount" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ item.category }}</td>
                  <td>{{ item.amount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--end table header -->
        </section>
        <section class="w-100">
          <div class="row">
            <div
              class="col-md-12 d-flex justify-content-end"
              v-if="filteredEvents.length > 0 || searchText !== ''"
            >
              <div class="col-md-4 col-12 px-0 mt-5" v-if="!displayTitle">
                <el-input
                  v-model="searchText"
                  size="small"
                  placeholder="Search..."
                  :suffix-icon="Search"
                />
              </div>
            </div>
          </div>
          <div
            v-if="filteredEvents.length > 0"
            class="container-fluid table-main px-0 remove-styles2 remove-border responsiveness mb-5 mt-2"
            id="table"
            :class="{ 'show-report': showReport, 'hide-report': !showReport }"
          >
            <table
              class="table remove-styles mt-0 table-hover table-header-area"
            >
              <thead class="table-header-area-main">
                <tr class="text-capitalize text-nowrap font-weight-bold">
                  <th scope="col">Event Name & Date</th>
                  <th scope="col" v-for="cat in categories" :key="cat">
                    {{ cat }}
                  </th>
                  <th scope="col">Total</th>
                </tr>
              </thead>

              <tbody class="font-weight-bold small-text text-nowrap">
                <tr v-for="(event, index) in filteredEvents" :key="index">
                  <td>{{ event.name }}</td>
                  <td v-for="cat in categories" :key="cat">
                    {{ event.attendance[cat] || 0 }}
                  </td>
                  <td class="font-weight-bold">
                    {{ getRowTotal(event).toLocaleString() || "" }}
                  </td>
                </tr>

                <!-- Total Row -->
                <tr>
                  <td class="font-weight-bold">Average Total</td>
                  <td
                    class="font-weight-bold"
                    v-for="cat in categories"
                    :key="cat"
                  >
                    {{ categoryAverages[cat].toLocaleString() || "" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, nextTick, inject } from "vue";
import PerformanceColumnChart from "../../../components/charts/ReportColumnChart.vue";
import PerformanceColumn from "./component/chart/PerformanceColumnChart.vue";
import groupData from "../../../services/groupArray/groupResponse";
import ReportAreaChart from "../../../components/charts/AreaChart.vue";
import axios from "@/gateway/backendapi";
import router from "../../../router";
import { Search } from "@element-plus/icons-vue";
import dateFormatter from "../../../services/dates/dateformatter.js";
import exportService from "../../../services/exportFile/exportservice";
import printJS from "print-js";
import { ElNotification } from "element-plus";
import SelectAllDropdown from "../../Reports/ReportsDropdown.vue";
import LineChart from "../../../components/charts/LineChart.vue";
export default {
  components: {
    PerformanceColumnChart,
    ReportAreaChart,
    SelectAllDropdown,
    PerformanceColumn,
    LineChart,
  },
  setup() {
    const showReport = ref(false);
    const loading = ref(false);
    const fileName = ref("Church Activities Attendance Report");
    const primarycolor = inject("primarycolor");
    const selectedFileType = ref({});
    const fileHeaderToExport = ref([]);
    const fileToExport = ref([]);
    const bookTypeList = ref([
      { name: "xlsx" },
      { name: "csv" },
      { name: "txt" },
      { name: "pdf" },
    ]);
    const showExport = ref(false);
    const searchText = ref("");
    const displayTitle = ref(false);
    const allEvents = ref([]);
    const selectedEvents = ref([]);
    const series = ref([]);
    const activityReport = ref([]);
    const attendanceSeries = ref([]);
    const startDate = ref(new Date().setFullYear(new Date().getFullYear() - 1));
    const endDate = ref(new Date(Date.now()));
    const attendanceData = ref([]);
    const babiesData = ref([]);
    const womenData = ref([]);
    const maleData = ref([]);
    const boyData = ref([]);
    const girlData = ref([]);
    const ChildrenData = ref([]);
    const TeenagersData = ref([]);
    const SinglesData = ref([]);
    const mainAttendanceData = ref([]);
    const categoryData = ref([]);
    const attendanceGroup = ref({});
    const grousService = ref([]);
    const selectedEventID = ref(null);
    const groupedActivityService = ref([]);
    const branchItem = ref({});
    branchItem.value = JSON.parse(localStorage.getItem("branchItem"));
    // const downloadFile = (item) => {
    //   if (item.name === "pdf") {
    //     displayTitle.value = true;
    //   } else {
    //     displayTitle.value = false;
    //   }
    //   exportService.downLoadExcel(
    //     item.name,
    //     document.getElementById("element-to-print"),
    //     fileName.value,
    //     fileHeaderToExport.value,
    //     fileToExport.value
    //   );
    // };
    const downloadFile = async (item) => {
      if (item.name === "pdf") {
        displayTitle.value = true;
        await nextTick();
        exportService.downLoadExcel(
          item.name,
          document.getElementById("element-to-print"),
          fileName.value,
          fileHeaderToExport.value,
          fileToExport.value
        );
      } else {
        displayTitle.value = false;
        exportService.downLoadExcel(
          item.name,
          document.getElementById("element-to-print"),
          fileName.value,
          fileHeaderToExport.value,
          fileToExport.value
        );
      }
    };
    const setSelectedEvent = (payload) => {
      selectedEvents.value = payload;
      console.log(payload, "kkkkkkkkkkkkkkkkkkkkkkkkk");
    };

    // const setSelectedEvent = () => {
    //   selectedEvents.value = allEvents.value.find(
    //     (i) => i.id === selectedEventID.value
    //   );
    //   console.log(selectedEvents.value, "Events");
    // };

    const goBack = () => {
      router.go(-1);
    };

    const getAllEvents = () => {
      if (branchItem.value && branchItem.value.id) {
        axios
          .get(
            `/api/BranchReports/events/getEvents?branchId=${branchItem.value.id}`
          )
          .then((res) => {
            allEvents.value = res.data;
          })
          .catch((err) => console.log(err));
      } else {
        axios
          .get("/api/Reports/events/getEvents")
          .then((res) => {
            allEvents.value = res.data;
          })
          .catch((err) => console.log(err));
      }
    };
    getAllEvents();
    const getRowTotal = (event) => {
      return categories.value.reduce((sum, cat) => {
        return sum + (event.attendance[cat] || 0);
      }, 0);
    };
    // Step 1: Extract unique categories
    const categories = computed(() => {
      return [
        ...new Set(activityReport.value.map((i) => i.attendanceCategory)),
      ];
    });
    const filteredEvents = computed(() => {
      const query = searchText.value.trim().toLowerCase();

      const grouped = {};

      activityReport.value.forEach((rec) => {
        const key = `${rec.name} ${rec.date}`;
        if (!grouped[key]) {
          grouped[key] = {
            name: rec.name,
            date: rec.date,
            attendance: {},
          };
        }
        grouped[key].attendance[rec.attendanceCategory] = rec.attendance;
      });

      let events = Object.values(grouped);

      // 🔎 Apply search filter
      if (query) {
        events = events.filter(
          (event) =>
            event.name.toLowerCase().includes(query) ||
            event.date.toLowerCase().includes(query) ||
            Object.entries(event.attendance)
              .map(([cat, val]) => `${cat} ${val}`)
              .join(" ")
              .toLowerCase()
              .includes(query)
        );
      }

      return events;
    });

    // Step 3: Total row

    const getCategoryTotal = (category) => {
      return activityReport.value
        .filter((i) => i.attendanceCategory === category)
        .reduce((sum, i) => sum + i.attendance, 0);
    };

    const categoryAverages = computed(() => {
      const averages = {};
      const count = filteredEvents.value.length;

      categories.value.forEach((cat) => (averages[cat] = 0));

      if (count === 0) return averages;

      filteredEvents.value.forEach((event) => {
        categories.value.forEach((cat) => {
          averages[cat] += event.attendance[cat] || 0;
        });
      });

      // Divide sum by number of events to get average
      categories.value.forEach((cat) => {
        averages[cat] = (averages[cat] / count).toFixed(1); // keep 1 decimal
      });

      return averages;
    });

    const groupCategorySeries = () => {
      attendanceGroup.value = groupData.groupData(
        activityReport.value,
        "attendanceCategory"
      );
      const dateSeries = groupData.groupData(activityReport.value, "date");
      for (const prop in dateSeries) {
        attendanceSeries.value.unshift(dateFormatter.monthDayYear(prop));
      }
    };

    const groupCategory = () => {
      const cleanData = activityReport.value.filter(
        (d) => d.attendanceCategory && d.attendance > 0
      );
      const grouped = groupData.groupData(cleanData, "attendanceCategory");
      groupedActivityService.value = [];
      for (const category in grouped) {
        let total = grouped[category].reduce(
          (sum, item) => sum + item.attendance,
          0
        );

        // sort by event date (assuming `eventDate` exists)
        const sortedDetails = grouped[category]
          .sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate))
          .map((d) => ({
            name: `${d.name}`, // e.g. "Sunday 07-03-2025"
            attendance: d.attendance,
          }));

        groupedActivityService.value.push({
          category,
          total,
          details: sortedDetails,
        });
      }
    };

    const getActivityReport = () => {
      activityReport.value = [];
      // const eventId = selectedEvents.value ? selectedEvents.value.id : "";
      const eventId = selectedEvents.value.map((i) => i.id);

      loading.value = true;
      if (branchItem.value && branchItem.value.id) {
        axios
          .get(
            `/api/BranchReports/events/getActivityAttendanceReport?startDate=${new Date(
              startDate.value
            ).toLocaleDateString("en-US")}&endDate=${new Date(
              endDate.value
            ).toLocaleDateString("en-US")}&activityId=${eventId}&branchId=${
              branchItem.value.id
            }`
          )
          .then((res) => {
            activityReport.value = res.data;
            mainAttendanceData.value = [];
            attendanceData.value = [];
            series.value = [];
            groupCategory();
            groupCategorySeries();
            groupName();
            categoryData.value = [];
            getActivityServices();
            setTimeout(() => {
              fileHeaderToExport.value = exportService.tableHeaderToJson(
                document.getElementsByTagName("th")
              );
              fileToExport.value = exportService.tableToJson(
                document.getElementById("table")
              );
            }, 1000);
            showReport.value = true;
            loading.value = false;

            if (activityReport.value.length === 0) {
              ElNotification({
                type: "warning",
                showClose: true,
                message: "No data for this date range",
                duration: 5000,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            loading.value = false;
          });
      } else {
        axios
          .get(
            `/api/Reports/events/getActivityAttendanceReport?startDate=${new Date(
              startDate.value
            ).toLocaleDateString("en-US")}&endDate=${new Date(
              endDate.value
            ).toLocaleDateString("en-US")}&activityId=${eventId}`
          )
          .then((res) => {
            activityReport.value = res.data;
            mainAttendanceData.value = [];
            attendanceData.value = [];
            series.value = [];
            groupCategory();
            groupCategorySeries();
            groupName();
            categoryData.value = [];
            getActivityServices();
            setTimeout(() => {
              fileHeaderToExport.value = exportService.tableHeaderToJson(
                document.getElementsByTagName("th")
              );
              fileToExport.value = exportService.tableToJson(
                document.getElementById("table")
              );
            }, 1000);
            showReport.value = true;
            loading.value = false;

            if (activityReport.value.length === 0) {
              ElNotification({
                type: "warning",
                showClose: true,
                message: "No data for this date range",
                duration: 5000,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            loading.value = false;
          });
      }
    };

    const getReport = () => {
      activityReport.value = [];
      // const eventId = selectedEvents.value ? selectedEvents.value.id : "";
      const eventId = selectedEvents.value.map((i) => i.id);

      loading.value = true;
      if (branchItem.value && branchItem.value.id) {
        axios
          .get(
            `/api/BranchReports/events/getActivityAttendanceReport?startDate=${new Date(
              startDate.value
            ).toLocaleDateString("en-US")}&endDate=${new Date(
              endDate.value
            ).toLocaleDateString("en-US")}&activityId=${eventId}&branchId=${
              branchItem.value.id
            }`
          )
          .then((res) => {
            activityReport.value = res.data;
            mainAttendanceData.value = [];
            attendanceData.value = [];
            series.value = [];
            groupCategory();
            groupCategorySeries();
            groupName();
            categoryData.value = [];
            getActivityServices();
            setTimeout(() => {
              fileHeaderToExport.value = exportService.tableHeaderToJson(
                document.getElementsByTagName("th")
              );
              fileToExport.value = exportService.tableToJson(
                document.getElementById("table")
              );
            }, 1000);
            showReport.value = true;
            loading.value = false;

            if (activityReport.value.length === 0) {
              ElNotification({
                type: "warning",
                showClose: true,
                message: "No data for this date range",
                duration: 5000,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            loading.value = false;
          });
      } else {
        axios
          .get(
            `/api/Reports/events/getActivityAttendanceReport?startDate=${new Date(
              startDate.value
            ).toLocaleDateString("en-US")}&endDate=${new Date(
              endDate.value
            ).toLocaleDateString("en-US")}&activityId=${eventId}`
          )
          .then((res) => {
            activityReport.value = res.data;
            mainAttendanceData.value = [];
            attendanceData.value = [];
            series.value = [];
            groupCategory();
            groupCategorySeries();
            groupName();
            categoryData.value = [];
            getActivityServices();
            setTimeout(() => {
              fileHeaderToExport.value = exportService.tableHeaderToJson(
                document.getElementsByTagName("th")
              );
              fileToExport.value = exportService.tableToJson(
                document.getElementById("table")
              );
            }, 1000);
            showReport.value = true;
            loading.value = false;

            if (activityReport.value.length === 0) {
              ElNotification({
                type: "warning",
                showClose: true,
                message: "No data for this date range",
                duration: 5000,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            loading.value = false;
          });
      }
    };
    getReport();

    const buildLineChartData = (metricKey) => {
      // Collect all months in order
      const categories = [
        ...new Set(activityReport.value.map((r) => r.monthYear)),
      ];

      // Collect all unique events
      const events = [...new Set(activityReport.value.map((r) => r.eventName))];

      // Build series for each event
      const series = events.map((event) => {
        const data = categories.map((month) => {
          const items = activityReport.value.filter(
            (r) => r.eventName === event && r.monthYear === month
          );
          return items.reduce((sum, r) => sum + (r[metricKey] || 0), 0);
        });

        return {
          name: event,
          data,
        };
      });

      return { categories, series };
    };
    const attendanceChart = computed(() => buildLineChartData("attendance"));

    const buildClusteredStackedData = () => {
      const categories = [
        ...new Set(activityReport.value.map((r) => r.monthYear)),
      ];
      const seriesArr = [];
      const events = [...new Set(activityReport.value.map((r) => r.eventName))];
      const groups = [
        ...new Set(activityReport.value.map((r) => r.attendanceCategory)),
      ];

      events.forEach((event) => {
        groups.forEach((group) => {
          const data = categories.map((month) => {
            const items = activityReport.value.filter(
              (r) =>
                r.eventName === event &&
                r.monthYear === month &&
                r.attendanceCategory === group
            );
            return items.reduce((sum, r) => sum + (r.attendance || 0), 0);
          });

          seriesArr.push({
            name: group,
            data,
            stack: event,
          });
        });
      });

      return { categories, series: seriesArr };
    };

    // example computed
    const attendanceChartData = computed(() => buildClusteredStackedData());

    const groupName = () => {
      const result = groupData.groupData(activityReport.value, "name");
      for (const prop in result) {
        grousService.value.push({
          name: prop,
          value: result[prop],
        });
      }

      grousService.value.forEach((i) => {
        i.value.forEach((j) => {
          groupedActivityService.value.push({
            name: i.name.split(",").join(""),
            category: j.attendanceCategory,
            amount: j.attendance,
          });
        });
      });
    };
    // const groupName = () => {
    //   groupedActivityService.value = []; // reset first

    //   // group by category
    //   const grouped = groupData.groupData(
    //     activityReport.value,
    //     "attendanceCategory"
    //   );

    //   for (const category in grouped) {
    //     const details = grouped[category]
    //       .sort((a, b) => new Date(a.date) - new Date(b.date)) // sort by date
    //       .map((d) => ({
    //         name: `${d.name}`,
    //         attendance: d.attendance,
    //       }));

    //     // skip empty categories
    //     if (!details.length) continue;

    //     const total = details.reduce((sum, d) => sum + d.attendance, 0);

    //     groupedActivityService.value.push({
    //       category,
    //       details,
    //       total,
    //     });
    //   }
    // };

    // const attendanceChart = computed(() => {
    //   if (activityReport.value.length === 0) return [];
    //   activityReport.value.forEach((i) => {
    //     let attendanceIndex = Object.keys(i).findIndex(
    //       (i) => i === "attendance"
    //     );
    //     let attendanceValue = Object.values(i)[attendanceIndex];
    //     attendanceData.value.unshift(attendanceValue);
    //   });

    //   mainAttendanceData.value.push({
    //     name: "Attendance",
    //     color: "#f94144",
    //     data: attendanceData.value,
    //   });
    //   return mainAttendanceData.value;
    // });
    const getActivityServices = () => {
      activityReport.value.forEach((i) => {
        let serviceIndex = Object.keys(i).findIndex((i) => i === "date");
        let serviceValue = Object.values(i)[serviceIndex];
        series.value.unshift(dateFormatter.monthDayYear(serviceValue));
      });
    };

    const summaryChart = computed(() => {
      if (Object.keys(attendanceGroup.value).length === 0) return new Object();
      Object.entries(attendanceGroup.value).forEach(([key, value]) => {
        let newArr = [];
        value.forEach((i) => {
          let valIndex = Object.keys(i).findIndex((i) => i === "attendance");
          let attValue = Object.values(i)[valIndex];
          newArr.unshift(attValue);
        });
        categoryData.value.push({
          name: key,
          color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
          data: newArr,
        });
      });

      return categoryData.value;
    });

    const formatDate = (date) => {
      return dateFormatter.monthDayYear(date);
    };

    return {
      attendanceChartData,
      getRowTotal,
      categoryAverages,
      branchItem,
      filteredEvents,
      categories,
      getCategoryTotal,
      formatDate,
      Search,
      searchText,
      loading,
      primarycolor,
      startDate,
      endDate,
      selectedEvents,
      displayTitle,
      allEvents,
      activityReport,
      getActivityReport,
      series,
      attendanceSeries,
      attendanceChart,
      womenData,
      maleData,
      setSelectedEvent,
      selectedEventID,
      boyData,
      girlData,
      ChildrenData,
      TeenagersData,
      SinglesData,
      attendanceData,
      mainAttendanceData,
      categoryData,
      babiesData,
      summaryChart,
      attendanceGroup,
      grousService,
      showExport,
      printJS,
      downloadFile,
      goBack,
      bookTypeList,
      selectedFileType,
      fileHeaderToExport,
      fileToExport,
      fileName,
      showReport,
      groupedActivityService,
    };
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 400 !important;
  color: #000000 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #f4f4f4;
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.round-border {
  border-radius: 0.5rem;
  box-shadow: 0 0.063rem 0.25rem #02172e45;
  border: 0.063rem solid #dde2e6;
}

.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  border: 0.063rem solid #dde2e6 !important;
  border-radius: 30px !important;
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}
.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.remove-border {
  box-shadow: none !important;
}
.tablerow-style {
  min-width: 100%;
  border-bottom: 0px;
}

.graph-area {
  border: 1px solid #dde2e6;
  border-radius: 0.5rem;
  padding: 1rem 0rem;
  margin: 2rem 0rem;
}

.responsiveness {
  max-width: 100%;
  overflow-y: scroll;
}

.p-multiselect {
  width: 18rem;
}

.multiselect-custom {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.country-item-value {
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: 0.5rem;
  /* background-color:  */
  /* background-color: var(--primary-color); */
  /* color: var(--primary-color-text); */
}
.border {
  border-color: #b0b2b5 !important;
  border-radius: 15px !important;
}
.lineGrap {
  border-radius: 0.5rem;
  box-shadow: 0 0.063rem 0.25rem #02172e45;
  border: 0.063rem solid #dde2e6;
  font-weight: bold;
}
.borderInner {
  width: 100%;
  /* height: 700px; */
}
img.flag {
  width: 17px;
}
.primary-bg {
  background-color: rgb(19, 106, 205) !important;
  border-style: none !important;
}
.p-button.p-button-icon-only {
  background-color: red !important;
}

@media screen and (max-width: 640px) {
  .p-multiselect {
    width: 100%;
  }
}
</style>
